import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cValidators } from '../../../models/validator';

export interface DialogData {
  mensaje?: string;
}

export interface EventData {
  result: string;
}

@Component({
  selector: 'dialog-internal-message',
  templateUrl: 'dialog-internal-message.component.html',
  styleUrls: ['./dialog-internal-message.component.scss']
})
export class DialogInternalMessage {
  internalMessageValidator: FormControl = new FormControl(this.data.mensaje, cValidators.required);

  @Output() finish = new EventEmitter<EventData>();

  /**
  * Object for the dialog component icon
  */
  icon = 'chat';

  constructor(
    public dialogRef: MatDialogRef<DialogInternalMessage>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog(): void {
    if (!this.internalMessageValidator.valid) {
      this.internalMessageValidator.updateValueAndValidity();

      return;
    }

    this.finish.emit({
      result: this.internalMessageValidator.value
    });
  }
}
